import { __extends } from "tslib";
import React, { Component } from 'react';
import InlineToolbarButton from '../../../components/Buttons/InlineToolbarButton';
import ColorDropIcon from '../../../../Icons/ColorDrop';
import s from '../components/ColorPicker.scss';
var TextColorButton = /** @class */ (function (_super) {
    __extends(TextColorButton, _super);
    function TextColorButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, helpers = _a.helpers, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState, customStylesPlugin = _a.customStylesPlugin;
            if (helpers && helpers.openColorPicker) {
                var toolbarEl = _this.getToolbarElement(e);
                helpers.openColorPicker({ getEditorState: getEditorState, setEditorState: setEditorState, customStylesPlugin: customStylesPlugin, toolbarEl: toolbarEl }, _this.onColorPickerDone);
            }
        };
        _this.getToolbarElement = function (e) {
            return e.currentTarget;
        };
        _this.onColorPickerDone = function () {
            // Nothing currently...
        };
        return _this;
    }
    TextColorButton.prototype.render = function () {
        var _a = this.props, theme = _a.theme, isMobile = _a.isMobile, tabIndex = _a.tabIndex;
        var Icon = function () { return React.createElement(ColorDropIcon, { className: s['drop-icon'] }); };
        return (React.createElement(InlineToolbarButton, { onClick: this.handleClick, isActive: true, theme: theme, isMobile: isMobile, tooltipText: undefined, tabIndex: tabIndex, icon: Icon }));
    };
    return TextColorButton;
}(Component));
export default TextColorButton;
//# sourceMappingURL=ColorButton.js.map